import React, { useState } from 'react';

const SolutionSection = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <section
      id="solution"
      className="solution-section"
      style={{
        background: '#0F0F1A',
        padding: '5px 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Декоративные фигуры на фоне */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          zIndex: 1,
        }}
      >
        {/* Круг 1 - cyan-violet */}
        <div
          style={{
            position: 'absolute',
            width: '400px',
            height: '400px',
            top: '-150px',
            left: '-150px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #22D3EE, #8B5CF6)',
            filter: 'blur(100px)',
            opacity: 0.15,
          }}
        />

        {/* Круг 2 - pink-gold */}
        <div
          style={{
            position: 'absolute',
            width: '500px',
            height: '500px',
            bottom: '-200px',
            right: '-200px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #EC4899, #FBBF24)',
            filter: 'blur(120px)',
            opacity: 0.15,
          }}
        />

        {/* Ромб */}
        <div
          style={{
            position: 'absolute',
            width: '120px',
            height: '120px',
            top: '15%',
            right: '15%',
            background: 'linear-gradient(135deg, #22D3EE, #8B5CF6)',
            transform: 'rotate(45deg)',
            opacity: 0.08,
            borderRadius: '16px',
          }}
        />

        {/* Декоративные иконки на фоне */}
        <img
                loading="lazy"
          src="/images/icons/rocket.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            top: '8%',
            left: '3%',
            transform: 'rotate(-15deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatSolution1 6s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/chart.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            bottom: '15%',
            left: '5%',
            transform: 'rotate(10deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatSolution2 7s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/box.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            top: '10%',
            right: '20%',
            transform: 'rotate(20deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatSolution3 5.5s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/coins.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            bottom: '25%',
            right: '3%',
            transform: 'rotate(-10deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'floatSolution4 6.5s ease-in-out infinite',
          }}
        />
      </div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 2,
        }}
      >
        {/* Badge */}
        <span
          style={{
            display: 'inline-block',
            background: 'rgba(255, 255, 255, 0.1)',
            color: '#FFFFFF',
            fontSize: '14px',
            fontWeight: 500,
            padding: '12px 24px',
            borderRadius: '50px',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginTop: '30px',
            marginBottom: '40px',
          }}
        >
          РЕШЕНИЕ
        </span>

        <div
          className="solution-layout"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '30px',
          }}
        >
          {/* Левая колонка */}
          <div
            className="solution-left"
            style={{
              flex: 1,
              maxWidth: '540px',
              position: 'relative',
              zIndex: 3,
            }}
          >
            {/* Заголовок */}
            <h2
              style={{
                fontSize: '52px',
                fontWeight: 800,
                color: '#FFFFFF',
                textTransform: 'uppercase',
                lineHeight: 1.05,
                margin: '0 0 28px 0',
              }}
              className="solution-title"
            >
              ПРОДВИЖЕНИЕ
              <br />
              <span
                style={{
                  background: 'linear-gradient(90deg, #22D3EE 0%, #8B5CF6 50%, #EC4899 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                МАРКЕТПЛЕЙСА
              </span>
              <br />
              УСЛУГИ
            </h2>

            {/* Иконки WB/OZON + текст */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '28px',
              }}
            >
              <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
                <img
                loading="lazy"
                  src="/images/marketplaces/wb.png"
                  alt="WB"
                  style={{ width: '48px', height: '48px', borderRadius: '12px', objectFit: 'cover' }}
                />
                <img
                loading="lazy"
                  src="/images/marketplaces/Ozon.webp"
                  alt="Ozon"
                  style={{ width: '48px', height: '48px', borderRadius: '12px', objectFit: 'cover' }}
                />
              </div>
              <div
                style={{
                  fontSize: '20px',
                  fontWeight: 700,
                  color: '#FFFFFF',
                  textTransform: 'uppercase',
                  lineHeight: 1.3,
                }}
                className="solution-mp-text"
              >
                УВЕЛИЧИМ ПРИБЫЛЬ Х3
                <br />
                И ВСЕМУ НАУЧИМ
              </div>
            </div>

            {/* Описание */}
            <p
              style={{
                fontSize: '15px',
                fontWeight: 400,
                color: 'rgba(255, 255, 255, 0.65)',
                lineHeight: 1.7,
                margin: '0 0 36px 0',
              }}
              className="solution-desc"
            >
              Мы гарантируем по договору результат внутри Ваших магазинов. Используем собственную технологию продаж. Улучшаем поведенческие факторы внутри карточек товаров. Увеличиваем CTR внутри магазина (поиск, карточка, корзина, заказ). Заранее прогнозируем выручку внутри магазина и расходы, отчитываемся перед вами и согласовываем цифры. Профессионально управляем рекламными компаниями и отвечаем за результат.
            </p>

            {/* Кнопка CTA */}
            <button
              className="solution-btn"
              style={{
                background: 'linear-gradient(135deg, #F97316 0%, #EC4899 100%)',
                border: 'none',
                color: '#FFFFFF',
                fontSize: '16px',
                fontWeight: 600,
                textTransform: 'uppercase',
                padding: '20px 48px',
                borderRadius: '50px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(249, 115, 22, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
              }}
              onClick={() => window.dispatchEvent(new Event('openModal'))}
            >
              ПОЛУЧИТЬ КОНСУЛЬТАЦИЮ →
            </button>
          </div>

          {/* Правая колонка - девушка с градиентной рамкой */}
          <div
            className="solution-right"
            style={{
              flexShrink: 0,
              position: 'relative',
              width: '550px',
              height: '650px',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {/* Градиентная рамка - повернута на -75° */}
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: isHovered
                  ? 'translate(calc(-50% - 15px), -50%) rotate(-75deg)'
                  : 'translate(-50%, -50%) rotate(-75deg)',
                width: '450px',
                height: '550px',
                background: 'linear-gradient(135deg, #22D3EE 0%, #8B5CF6 35%, #EC4899 65%, #FBBF24 100%)',
                borderRadius: '40px',
                zIndex: 1,
                transition: 'transform 0.3s ease',
              }}
            />

            {/* Серый полупрозрачный прямоугольник - повернут на 120° */}
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: isHovered
                  ? 'translate(calc(-50% + 15px), -50%) rotate(120deg)'
                  : 'translate(-50%, -50%) rotate(120deg)',
                width: '400px',
                height: '500px',
                background: 'rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                borderRadius: '32px',
                zIndex: 2,
                transition: 'transform 0.3s ease',
              }}
            />

            {/* Девушка - наложением сверху */}
            <img
                loading="lazy"
              src="/images/icons/noroot.webp"
              alt=""
              style={{
                position: 'absolute',
                bottom: 0,
                left: '53%',
                transform: 'translateX(-50%)',
                height: '100%',
                width: 'auto',
                objectFit: 'contain',
                zIndex: 3,
              }}
            />
          </div>
        </div>
      </div>

      {/* Анимации */}
      <style>
        {`
          @media (max-width: 1024px) {
            .solution-layout { flex-direction: column !important; gap: 40px !important; }
            .solution-left { max-width: 100% !important; }
            .solution-right { width: 100% !important; height: 450px !important; }
            .solution-title { font-size: 38px !important; }
          }
          @media (max-width: 768px) {
            .solution-section { padding: 40px 0 0 0 !important; }
            .solution-title { font-size: 28px !important; }
            .solution-right { height: 350px !important; }
            .solution-right .solution-grad-rect { width: 300px !important; height: 380px !important; }
            .solution-right .solution-glass-rect { width: 260px !important; height: 340px !important; }
            .solution-desc { font-size: 14px !important; }
            .solution-btn { padding: 16px 32px !important; font-size: 14px !important; }
            .solution-mp-text { font-size: 16px !important; }
            .solution-bg-icon { display: none !important; }
          }
          @media (max-width: 480px) {
            .solution-title { font-size: 24px !important; }
            .solution-right { height: 300px !important; }
            .solution-right .solution-grad-rect { width: 250px !important; height: 320px !important; }
            .solution-right .solution-glass-rect { width: 220px !important; height: 280px !important; }
            .solution-btn { padding: 14px 24px !important; font-size: 13px !important; }
          }

          @keyframes floatSolution1 {
            0%, 100% { transform: translate(0, 0) rotate(-15deg); }
            50% { transform: translate(-10px, -15px) rotate(-15deg); }
          }

          @keyframes floatSolution2 {
            0%, 100% { transform: translate(0, 0) rotate(10deg); }
            50% { transform: translate(-15px, -10px) rotate(10deg); }
          }

          @keyframes floatSolution3 {
            0%, 100% { transform: translate(0, 0) rotate(20deg); }
            50% { transform: translate(10px, -20px) rotate(20deg); }
          }

          @keyframes floatSolution4 {
            0%, 100% { transform: translate(0, 0) rotate(-10deg); }
            50% { transform: translate(15px, -15px) rotate(-10deg); }
          }
        `}
      </style>
    </section>
  );
};

export default SolutionSection;
